<template>
  <base-popover
    :id="id"
    ref="popover"
    :shown="shown"
    :confirm-before-close="confirmBeforeClose"
    :disabled="disabled"
    :placement="placement"
    :distance="distance"
    :shift="shift"
    :boundary="boundary"
    :flip="flip"
    :auto-boundary-max-size="autoBoundaryMaxSize"
    :overflow-padding="overflowPadding"
    :prevent-overflow-on-cross-axis="preventOverflowOnCrossAxis"
    :content-class="computedContentClass"
    :will-change="willChange"
    :max-height="maxHeight"
    :strategy="strategy"
    :middlewares="middlewares"
    :reference="reference"
    :add-layer="addLayer"
    @update:shown="handleShown"
    @shown="$emit('shown')"
    @hidden="$emit('hidden')"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
  >
    <template #default="{ hide, show, toggle, disabled: isDisabled, shown: isShown }">
      <slot
        :hide="hide"
        :show="show"
        :toggle="toggle"
        :disabled="isDisabled"
        :shown="isShown"
      />
    </template>
    <template #content="{ hide, maxHeight }">
      <slot
        name="content"
        :hide="hide"
        :max-height="maxHeight"
      />
    </template>
  </base-popover>
</template>

<script>
import BasePopover from '@/shared/legacy/ui/base-dropdown/base-popover/base-popover.vue';

export default {
  name: 'BaseDropdown',
  components: {
    BasePopover
  },
  props: {
    id: BasePopover.props.id,
    shown: BasePopover.props.shown,
    confirmBeforeClose: BasePopover.props.confirmBeforeClose,
    disabled: BasePopover.props.disabled,
    placement: BasePopover.props.placement,
    distance: BasePopover.props.distance,
    shift: BasePopover.props.shift,
    boundary: BasePopover.props.boundary,
    flip: BasePopover.props.flip,
    autoBoundaryMaxSize: BasePopover.props.autoBoundaryMaxSize,
    overflowPadding: {
      type: BasePopover.props.overflowPadding.type,
      default: () => ({
        top: 55 // Шоб под шапку не заежало
      })
    },
    contentClass: BasePopover.props.contentClass,
    preventOverflowOnCrossAxis: BasePopover.props.preventOverflowOnCrossAxis,
    willChange: BasePopover.props.willChange,
    maxHeight: BasePopover.props.maxHeight,
    strategy: BasePopover.props.strategy,
    middlewares: BasePopover.props.middlewares,
    reference: BasePopover.props.reference,
    addLayer: BasePopover.props.addLayer
  },
  emits: ['change', 'shown', 'hidden', 'focus', 'blur'],
  computed: {
    computedContentClass() {
      const defaultContentClass = {
        [this.$style.dropdown]: true
      };
      if (Array.isArray(this.contentClass)) {
        return [defaultContentClass, ...this.contentClass];
      }
      if (typeof this.contentClass === 'object' && this.contentClass) {
        return {
          ...defaultContentClass,
          ...this.contentClass
        };
      }
      if (typeof this.contentClass === 'string') {
        return {
          ...defaultContentClass,
          [this.contentClass]: true
        };
      }
      return defaultContentClass;
    }
  },
  methods: {
    handleShown(shown) {
      this.$emit('change', shown);
    },
    show() {
      this.$refs.popover.show();
    },
    hide() {
      this.$refs.popover.hide();
    },
    toggle() {
      this.$refs.popover.toggle();
    }
  }
};
</script>

<style module>
.dropdown {
  border-radius: 8px;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.16);
  background: $white;
  overflow: hidden auto;
  width: auto;
}
</style>

<i18n lang="json">{}</i18n>
